<template>
  <ResetPasswordDialog
    :dialogTitle="dialogTitle"
    :centerDialogVisible="visible"
    @updateVisible="updateVisible"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
    :popupWidth="'600px'"
    :appendToBody="false"
  >
    <el-form ref="query" :model="query" :rules="rule" label-width="120px">
      <el-form-item label="请输入新密码:" prop="newPassword">
        <el-input v-model.trim="query.newPassword" type="password"></el-input>
      </el-form-item>
      <el-form-item label="请确认新密码:" prop="confirmPassword">
        <el-input
          v-model.trim="query.confirmPassword"
          type="password"
        ></el-input>
      </el-form-item>
    </el-form>
  </ResetPasswordDialog>
</template>

<script>
import ResetPasswordDialog from "../../../../components/common/epecDialog";
import Api from "../../api/authority/index";
import ApiNesting from "../../api/nesting";
import { debounce } from "@/modules/projectA/utils/throttle.js";
export default {
  name: "resetPassword",
  components: {
    ResetPasswordDialog,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    let reg = /(?![0-9A-Z!@#$_%^*()]+$)(?![0-9a-z!@#$_%^*()]+$)(?![a-zA-Z!@#$_%^*()]+$)[0-9A-Za-z!@#$_%^*()]{8,20}$/;
    const validatePass = (rule, value, callback) => {
      let memberName = this.userData.memberName;
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (
        memberName == value.toLowerCase() ||
        value.toLowerCase().indexOf(memberName) != -1
      ) {
        callback(new Error("密码不得包含用户名"));
      } else if (!reg.test(value)) {
        callback(new Error("密码应是8-20位必须同时包括大小写字母及数字！"));
      } else if (this.passwordState == "101") {
        callback(new Error("密码过于简单，请重新设置密码"));
      } else if (this.passwordState == "102") {
        callback(new Error("不能使用前5次使用过的密码"));
      } else {
        if (this.query.confirmPassword !== "") {
          this.$refs.query.validateField("confirmPassword");
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.query.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      dialogTitle: "重置密码",
      query: {
        newPassword: "",
        confirmPassword: "",
      },
      rule: {
        newPassword: [
          { required: true, validator: validatePass, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
      passwordState: "",
    };
  },
  computed: {},
  created() {},
  methods: {
    updateVisible() {},
    resetPopupData() {
      this.$emit("close");
    },
    submitPopupData() {
      debounce(() => {
        if (this.query.newPassword) {
          // 弱口令
          let params = {
            memberId: this.userData.memberId,
            password: this.query.newPassword,
          };
          ApiNesting.weakPasswordCheck(params).then((res) => {
            if (res.data.status != "ok") {
              this.passwordState = res.data.status;
            }
            this.handleConfirmPassword();
          });
        } else {
          this.handleConfirmPassword();
        }
      }, 1000);
    },
    handleConfirmPassword() {
      let params = {
        memberId: this.userData.memberId,
        newPassword: this.query.newPassword,
        confirmPassword: this.query.confirmPassword,
      };
      this.$refs.query.validate((val) => {
        if (val) {
          Api.resetPassword(params).then((res) => {
            if (res.code == "200") {
              this.$message({
                type: "success",
                message: "修改密码成功",
              });
              this.$emit("close");
            }
          });
        } else {
          this.passwordState = "";
          console.log("error");
        }
      });
    },
  },
};
</script>

<style scoped></style>
